const apiBaseURL = 'https://irisback.licuas.es'; // 'http://localhost:8000';

export const appConfig: any = {

  apiConfig: {
    baseURL: apiBaseURL,
  }

};